import React from 'react';
import Header from './Header';
import { Link } from 'react-router-dom';
import avatar from '../assets/aimikel_avatar.png';
import location from '../svgs/location.svg';
import envelope from '../svgs/envelope.svg';
import phone from '../svgs/phone.svg';

import road_to_success from '../assets/road_to_success.png';
import web_dev from '../assets/web_dev.png';
import android_dev from '../assets/android_dev.png';
import graphic_design from '../assets/graphic_design.png';
import game_dev from '../assets/game_dev.png';
import keep_going from '../assets/keep_going.png';

function Home() {
	return (
		<React.Fragment>
			<Header appTitle="Home" />
			<div className="main-body home-page">
				<div className="into pd-md-v xl-pd-none sp-xl-h blob-t blob-b">
					<h2 className="font-bold txt-primary sp-md-top">Welcome to Aimikel Website</h2>
					<h3 className="sp-md-bottom">
						Hello World, Aim mikel here and this is my personal website. Your are probably here because you want to know{' '}
						<Link to="/about" className="font-bold txt-underline">
							who is Aim Mikel
						</Link>{' '}
						and all the associated facts about me or you definately have a{' '}
						<Link to="/services" className="font-bold txt-underline">
							Job
						</Link>{' '}
						for me. In either way, feel free to use this website.
					</h3>
				</div>
				<div className="profile-banner elevate bg-stripped bg-fixed flex align-center flex-column">
					<div className="avatar">
						<img src={avatar} alt="profile img" />
					</div>
					<div className="info pd-md flex flex-column align-center">
						<h2 className="font-bold">Michael Aloo</h2>
						<p className="">Bachelor ICT</p>
						<p className="">Web and Android Developer</p>
						<p className="sp-top flex align-center">
							<img className="h-20 w-20 pd-xs sp-right" src={phone} alt="" />
							+254 703 929 108
						</p>
						<p className="flex align-center">
							<img className="h-20 w-20 pd-xs sp-right" src={envelope} alt="" />
							michaelaloo.sudo@gmail.com
						</p>
						<p className="flex align-center">
							<img className="h-20 w-20 pd-xs sp-right" src={location} alt="" />
							Nakuru, Kenya
						</p>
					</div>
				</div>
				<div className="sp-xl-h">
					<h1 className="pd-md-v xl-pd-none">Road To Success</h1>
					<div className="flex align-center info-pane blob-t reverse">
						<div className="flex-grow">
							<h2 className="txt-primary">The First Step</h2>
							<p className="">
								As they say <b>"A Journey of a thousand miles start with a single step"</b>, the programming journey I took started long time ago. The first time, the first step was not that easy. It always feels very awkward and difficult when someone is starting something new. But what I can tell you is that the feeling is only real when you are a begginer. Then after, everything just feels nice and programming starts becoming part of your life. Something you can't live without. Never get afraid of starting.
							</p>
						</div>
						<div className="banner" style={{ backgroundImage: 'url(' + road_to_success + ')' }}></div>
					</div>
					<div className="flex align-center info-pane blob-t">
						<div className="banner" style={{ backgroundImage: 'url(' + web_dev + ')' }}></div>
						<div className="flex-grow">
							<h2 className="txt-primary">Web Development</h2>
							<p className="">Web development is one of my favorite programming areas and the one I have majored on. It is just one of the easiest areas any developer can do. Actually this is the area that made me fall in love with programming and it is one of the areas I started working on when programming started taking the better part of me. Since then, everything has been just awesome and I have built a lot of web projects making me experienced more in this area than any other.</p>
						</div>
					</div>
					<div className="flex align-center info-pane blob-t reverse">
						<div className="flex-grow">
							<h2 className="txt-primary">Android Development</h2>
							<p className="">I started learning android development a bit late. This was caused by the fact that android development requires a modern computer/laptop which I could not afford by then. This is one of the areas I have been working on lately and putting effort to gain more skills and experience. I have build a couple of apps and hope with time I will become a professional in this area too.</p>
						</div>
						<div className="banner" style={{ backgroundImage: 'url(' + android_dev + ')' }}></div>
					</div>
					<div className="flex align-center info-pane blob-t">
						<div className="banner" style={{ backgroundImage: 'url(' + graphic_design + ')' }}></div>
						<div className="flex-grow">
							<h2 className="txt-primary">Graphic Design</h2>
							<p className="">Being in the world of programming made me know and learn a lot of things. I started learning graphic design a few years back. By then I was just playing with photos and editing them for fun. I then started making logos and icons for web and andorid apps. I have specialized in creating svg and png icons and logos. Some of the icons I used in this website I created them myself including the logo.</p>
						</div>
					</div>
					<div className="flex align-center info-pane blob-t reverse">
						<div className="flex-grow">
							<h2 className="txt-primary">Game Development</h2>
							<p className="">I started making games after learning web development. This was motivated by one of my favorite programming languages, Javascript. I learnt to make 2D web games after realizing the power of javascript and HTML5 canvas element. Since then I have been able to build a couple of games including Tetris. Check the projects page for more info.</p>
						</div>
						<div className="banner" style={{ backgroundImage: 'url(' + game_dev + ')' }}></div>
					</div>
					<div className="flex align-center info-pane blob-t">
						<div className="banner" style={{ backgroundImage: 'url(' + keep_going + ')' }}></div>
						<div className="flex-grow">
							<h2 className="txt-primary">Keep Going</h2>
							<p className="">When you started, no one said it was going to be easy. Everything is just a matter of hardwork and making sacrifices. Just keep going no matter how difficult something is, keep fighting. Keep reading those books and watching those tutorials. Keep practicing day and night. This is the only way how developers are made. Always remember that whatever is worth doing takes time. This is how I have been able to become who I am today. One day you gonna come to see that all was worth it.</p>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Home;
